import { render, staticRenderFns } from "./commonSelect.vue?vue&type=template&id=a715d408&scoped=true"
import script from "./commonSelect.vue?vue&type=script&lang=js"
export * from "./commonSelect.vue?vue&type=script&lang=js"
import style0 from "./commonSelect.vue?vue&type=style&index=0&id=a715d408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a715d408",
  null
  
)

export default component.exports